import request from '@/utils/request'
// 查询收藏列表
export function collectList(query) {
  return request({
    url: '/web/collect/list',
    method: 'get',
    params: query
  })
}

// 取消收藏/收藏
export function updateCollect(data) {
  return request({
    url: '/web/collect/updateCollect',
    method: 'post',
    data: data
  })
}
